<template>
    <div id="product-page" :style="{minHeight: bodyHeight}">
        <div class="product-banner">
            <img :src="img | urlProtocol" alt="">
        </div>
        <div class="activity-detail">
            <h2>{{activeStatus}}<span>{{day}}</span>天<span>{{hour}}</span>时<span>{{minutes}}</span>分</h2>
            <div class="progress-bar">
                <b :style="{width: cent}"></b>
                剩余库存{{hasNum}}件 <span>{{cent}}</span>
            </div>
        </div>
        <div class="book-cent"></div>
        <div class="product-detail">
            <h2>{{commonName}}</h2>
            <div class="product-price">￥{{salePrice}} <span>￥{{price}}</span></div>
            <div class="book-tip">{{commonDesc}}</div>
        </div>
        <div class="activity-rules">
            <h2>活动规则</h2>
            <div>
                <p>1、预约后，请在有效期内凭预约成功的二维码到店铺以专享价购买，过期作废。</p>
                <p>2、一个预约二维码仅限购买一件爆款优品。</p>
                <p>3、该商品退货将按照专享价进行退款，且不退还预约资格。</p>
                <p>4、请妥善保管您的预约二维码，不得转借、转发，在您确认购买该商品后再请店铺收银人员进行扫描，一旦扫描即刻失效。</p>
                <p>5、图片仅供参考，具体以实物为准。</p>
            </div>
        </div>
        <div class="store-info">
            <h2>{{storeName}}</h2>
            <div>{{address}} <span>/ {{category}}</span></div>
        </div>
        <div id="book-btn" @click="booking(btnStatus)" :class="{'has-book': btnStatus == 0 || btnStatus == 1 || btnStatus == 2}">
            <template v-if="btnStatus == 0">来晚了，商品已经被预约完了</template>
            <template v-else-if="btnStatus == 1">已结束</template>
            <template v-else-if="btnStatus == 2">预订尚未开始</template>
            <template v-else>立即预约</template>
        </div>
    </div>
</template>
<script>
    import {Util} from '../commons/util'
    import Product from '@/components/commons/Product'
    import Server from '../services/Entrance';

    export default {
        name: 'Order',
        data () {
            return {
                bodyHeight: '',
                img: '',
                hasNum: '', // 已预约的件数
                cent: '',// 百分比
                day: '2',
                hour: '15',
                minutes: '40',
                salePrice: '2500',
                price: '4500',
                storeName: '',
                address: '',
                category: '',
                btnStatus: 30,
                startTime: '',
                endTime: '',
                shopLogo: '',
                floorName: '',
                shopBunk: '',
                ruleType: '',
                commonName: '',
                commonDesc: '',
                activeStatus: '距离活动结束还剩'
            }
        },
        // 生命周期钩子
        mounted () {

            this.bodyHeight = window.screen.height + 'px';

            document.title = '商品详情';
            if ($.isApp) {
                $.AppReady().done(function (Bridge) {
                    if ($.os.ios && typeof Bridge.documentNavStyle === "function") {
                        Bridge.documentNavStyle();
                    } else if ($.os.android) {
                        Bridge.setText({
                            titleText: '商品详情'
                        });
                    }

                    // 埋点
                    if ($.os.ios && typeof Bridge.documentNavStyle === "function") {
                        Bridge.setNewPageTitle("", "10009-null-100043/null-身边苏宁/苏宁广场业态首页/商品页-null-null-null");
                    } else if ($.os.android) {
                        Bridge.setNewPageTitle("10009-null-100043/null-身边苏宁/苏宁广场业态首页/商品页-null-null-null");
                    }
                })
            }

            setTimeout(() => {
                Util.saCustomInit('', '', 'http://c.m.suning.com/sidesunProduct.html', '');
            }, 500);
        },
        components: {
            Product
        },
        beforeRouteEnter(to, from, next) {

            let urlParams = to.params;
                Server.order.commonInfo(urlParams.commonId).then(data => {
                    next(vm => {
                        /*var endTime = Util.getStringTime(data.endTime);
                        var endDate = new Date().setFullYear(endTime.Y, endTime.M - 1, endTime.D);
                        var endD = new Date(endDate).setHours(endTime.h - 1, endTime.m, endTime.s);*/
                        var endD = new Date(data.endTime.replace(/-/g, '/').replace(/\.\d*/g, ''));
                        var startD = new Date(data.startTime.replace(/-/g, '/').replace(/\.\d*/g, ''));

                        function setTime() {
                            var nowTime = new Date();

                            if (startD.getTime() <= nowTime.getTime()) {
                                var resTime = new Date(endD).getTime() - nowTime.getTime();
                                var leave1 = resTime % (24 * 3600 * 1000);
                                var leave2 = leave1 % (3600 * 1000);
                                vm.day = Math.floor(resTime/(24*3600*1000));
                                vm.hour = Math.floor(leave1 /(3600*1000));
                                vm.minutes = Math.floor(leave2 / (60 * 1000));
                            } else {
                                var resTime = new Date(startD).getTime() - nowTime.getTime();
                                var leave1 = resTime % (24 * 3600 * 1000);
                                var leave2 = leave1 % (3600 * 1000);
                                vm.day = Math.floor(resTime/(24*3600*1000));
                                vm.hour = Math.floor(leave1 /(3600*1000));
                                vm.minutes = Math.floor(leave2 / (60 * 1000));
                                vm.activeStatus = '距离活动开始还剩';
                                vm.btnStatus = 2;
                            }
                            vm.img = data.commonImg;
                            vm.hasNum = data.commoNum;
                            vm.cent = (data.commoNum / data.count).toFixed(2) * 100 + '%';
                        }
                        setTime();

                        setInterval(() => {
                            setTime();
                        }, 1000 * 60);

                        vm.salePrice = data.sellPrice;
                        vm.price = data.price;
                        vm.storeName = data.shopName;
                        vm.address = data.floorName + ' ' + data.shopBunk;
                        vm.category = data.commonCategoryName;
                        vm.startTime = data.startTime;
                        vm.endTime = data.endTime;
                        vm.shopLogo = data.shopLogo;
                        vm.floorName = data.floorName;
                        vm.shopBunk = data.shopBunk;
                        vm.ruleType = data.ruleType;
                        vm.commonName = data.commonName;
                        vm.commonDesc = data.commonDesc;

                        if (data.commoNum == 0) {
                            //vm.btnStatus = '来晚了，商品已经被预约完了';
                            vm.btnStatus = 0;
                        } else {
                            if ((new Date(data.endTime.replace(/-/g, "/"))).getTime() < (new Date()).getTime()) {
                                //this.btnStatus = '已结束';
                                vm.btnStatus = 1;
                            }
                        }
                        console.log(data);
                    });
                });
        },
        methods: {

            booking(btnStatus) {

                if (btnStatus == 1 || btnStatus == 2 || btnStatus == 0) {
                    return;
                }

                Util.auth(() => {
                    let _this = this;
                    let urlParams = this.$route.params;
                    Server.order.createOrder(urlParams.commonId, urlParams.commonNo).then(data => {

                        if (data.code == 1) {
                            AlertBox({
                                type: 'mini',
                                msg: data.msg
                            });
                        } else if (data.code == 0) {
                            AlertBox({
                                type: 'mini',
                                msg: '预约成功'
                            });
                            let d = {
                                qrCodeUrl: data.data.qrCodeUrl,
                                startTime: _this.startTime,
                                endTime: _this.endTime,
                                shopLogo: _this.shopLogo,
                                shopName: _this.storeName,
                                floorName: _this.floorName,
                                shopBunk: _this.shopBunk
                            };

                            window.localStorage.setItem('qrdata', JSON.stringify(d));
                            setTimeout(() => {
                                this.$router.push({
                                    name: 'Qrcode',
                                });
                            }, 2000)
                        }
                    });
                });
            }
        }
    }
</script>
<style scoped>
    #product-page {
        padding-bottom: 123px;
        background: #f2f2f2;
    }

    .product-banner {
        background: #fff;
        width: 750px;
        height: 450px;

        img {
            display: block;
            overflow: hidden;
            width: 100%;
            height: 100%;
        }
    }
    .activity-detail {
        height: 117px;
        box-sizing: border-box;
        background: #f2f2f2;
        padding: 13px 19px;

        h2 {

            font-family: "PingFangSC-Medium";
            font-weight: bold;
            font-size:30px;
            color:#333333;

            span {
                margin: 0 5px;
                background:#ffaa00;
                border-radius:6px;
                width:42px;
                height:42px;
                line-height:42px;
                text-align: center;
                display: inline-block;
                color: #ffffff;
                font-weight: normal;
            }
        }

        .progress-bar {
            margin-top: 13px;
            width: 456px;
            height: 56px;
            line-height: 56px;
            background:#d8d8d8;
            border-radius: 200px;
            font-family:"PingFangSC-Medium";
            font-size:40px;
            color:#ffffff;
            transform: scale(0.5);
            padding: 0 20px;
            position: relative;
            transform-origin: left top;

            span {
                float: right;
            }

            b {
                 content: '';
                 display: block;
                 position: absolute;
                 top: 0;
                 left: 0;
                 height: 56px;
                 width: 100%;
                 border-radius: 200px;
                 z-index: -1;
                 background: #ffaa00;
             }
        }
    }
    .product-detail {
        margin-bottom: 10px;
        background: #fff;
        padding: 20px 19px;

        > h2 {
              font-weight: bold;
              font-family: "PingFangSC-Medium";
              font-size: 32px;
              color: #222222;
          }

          .product-price {
              margin-top: 10px;
              font-family:"PingFangSC-Regular";
              font-size:30px;
              color:#ff6600;

              span {
                  font-size:22px;
                  color:#b4b4b4;
                  margin-left: 12px;
                  text-decoration: line-through;
              }
          }
        .book-tip {
            margin-top: 23px;
            font-size:26px;
            color:#666666;
            line-height:40px;
        }
    }
    .activity-rules {
        padding: 20px 19px;
        background: #fff;
        font-size:26px;
        line-height: 40px;
        color:#666666;

        > h2 {
              font-weight: bold;
              font-family: "PingFangSC-Medium";
              font-size: 32px;
              margin-bottom: 15px;
              color: #222222;
          }
    }
    .store-info {
        padding: 20px;
        margin-top: 10px;
        position: relative;
        background: #fff;

        h2 {
            font-weight: bold;
            font-family:"PingFangSC-Regular";
            font-size:26px;
            color:#222222;
        }

        > div {
              margin-top: 10px;
              font-family: "PingFangSC-Regular";
              font-size: 24px;
              color: #ffaa00;
              text-indent: 30px;
              position: relative;
              text-align: left;

                &:before {
                     position: absolute;
                     left: 0;
                     content: '';
                     background: url("../assets/loca-icon.png") center center no-repeat;
                     width: 20px;
                     height: 26px;
                     background-size: 18px 24px;
                     top: 50%;
                     margin-top: -11px;
                 }

                span {
                    color: #ccc;
                }
          }
            &:after {
                content: '';
                display: block;
                background: url("../assets/arrow-icon.png");
                background-size: 15px 28px;
                width: 15px;
                height: 28px;
                position: absolute;
                right: 20px;
                top: 50%;
                margin-top: -14px;
            }
    }
    #book-btn {
        width: 100%;
        height: 98px;
        line-height: 98px;
        text-align: center;
        background:#ffaa00;
        position: fixed;
        bottom: 0;
        left: 0;
        font-family:"PingFangSC-Regular";
        font-size:34px;
        color:#ffffff;
        letter-spacing:0;

        &.has-book {
            font-size:34px;
            color: #fff;
            letter-spacing:0;
            background: #b3b3b3;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Product.vue